<template>
  <div class="">
    <div class="breadcrumb-area pos-relative w-100">
      <h5 class="mb-0">
        {{ getPageTitle() }}
      </h5>
      <div>
        <button class="btn btn-secondary mr-2" @click="cancel">Quay lại</button>
        <button class="btn btn-primary" @click="save" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
          Lưu
        </button>
      </div>
    </div>
    <div class="p-10  pt-15 b-t-1-869fb229">
      <form @submit.prevent="save" class="mx-4 mt-2">
        <!-- Thông tin merchant -->
        <div class="row">
          <div class="col-md-4">
            <h6 class="font-weight-bold mb-3">Thông tin merchant</h6>
            <div class="form-group">
              <label for="merchantName">Tên cửa hàng / merchant <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="merchantName" v-model="form.merchantName"
                :class="{ 'is-invalid': errors.merchantName }" placeholder="Nhập tên merchant"
                :disabled="isSupplementalUpdate">
              <div v-if="errors.merchantName" class="invalid-feedback">
                {{ errors.merchantName }}
              </div>
            </div>

            <div class="form-group">
              <label for="businessRegistrationNumber">ĐKKD <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="businessRegistrationNumber"
                v-model="form.businessRegistrationNumber" :class="{ 'is-invalid': errors.businessRegistrationNumber }"
                placeholder="Nhập số ĐKKD" :disabled="isSupplementalUpdate">
              <div v-if="errors.businessRegistrationNumber" class="invalid-feedback">
                {{ errors.businessRegistrationNumber }}
              </div>
            </div>
            <div class="form-group">
              <label for="merchantAddress">Địa chỉ cửa hàng / merchant <span class="text-danger">*</span></label>
              <textarea class="form-control" id="merchantAddress" v-model="form.merchantAddress"
                :class="{ 'is-invalid': errors.merchantAddress }" placeholder="Nhập địa chỉ merchant"
                 rows="3">
  </textarea>
              <div v-if="errors.merchantAddress" class="invalid-feedback">
                {{ errors.merchantAddress }}
              </div>
            </div>

            <div class="form-group">
              <label for="representativeName">Tên chủ cửa hàng <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="representativeName" v-model="form.representativeName"
                :class="{ 'is-invalid': errors.representativeName }" placeholder="Nhập tên chủ cửa hàng"
                >
              <div v-if="errors.representativeName" class="invalid-feedback">
                {{ errors.representativeName }}
              </div>
            </div>

            <div class="form-group">
              <label for="representativeEmail">Email chủ cửa hàng <span class="text-danger">*</span></label>
              <input type="email" class="form-control" id="representativeEmail" v-model="form.representativeEmail"
                :class="{ 'is-invalid': errors.representativeEmail }" placeholder="Nhập email chủ cửa hàng"
                >
              <div v-if="errors.representativeEmail" class="invalid-feedback">
                {{ errors.representativeEmail }}
              </div>
            </div>

            <div class="form-group">
              <label for="representativeMobile">Mobile chủ cửa hàng <span class="text-danger">*</span></label>
              <input type="tel" class="form-control" id="representativeMobile" v-model="form.representativeMobile"
                :class="{ 'is-invalid': errors.representativeMobile }" placeholder="Nhập số điện thoại chủ cửa hàng"
                >
              <div v-if="errors.representativeMobile" class="invalid-feedback">
                {{ errors.representativeMobile }}
              </div>
            </div>

            <div class="form-group">
              <label for="identityNumber">CCCD chủ cửa hàng <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="identityNumber" v-model="form.identityNumber"
                :class="{ 'is-invalid': errors.identityNumber }" placeholder="Nhập số CCCD chủ cửa hàng"
                >
              <div v-if="errors.identityNumber" class="invalid-feedback">
                {{ errors.identityNumber }}
              </div>
            </div>

               <div class="form-group">
              <label for="inviterEmail">Email người giới thiệu <span class="text-danger">*</span></label>
              <input type="email" class="form-control" id="representativeEmail" v-model="form.inviterEmail"
                :class="{ 'is-invalid': errors.inviterEmail }" placeholder="Nhập email người giới thiệu"
                >
              <div v-if="errors.representativeEmail" class="invalid-feedback">
                {{ errors.inviterEmail }}
              </div>
            </div>
            <div class="form-group">
                <label for="packageCode">Gói combo<span class="text-danger">*</span></label>
              <Select2 v-model="form.packageCode" :options="optionCombo" re :disabled="optionCombo?.length === 0" placeholder="Chọn combo"></Select2>
              <div v-if="errors.packageCode" class="invalid-feedback">
                  {{ errors.packageCode }}
              </div>
            </div>

            <div class="form-group">
              <label for="inviteCode">Mã giới thiệu</label>
              <input type="text" class="form-control" id="inviteCode" v-model="form.inviteCode"
                :class="{ 'is-invalid': errors.inviteCode }" placeholder="Nhập mã giới thiệu (không bắt buộc)"
                >
              <div v-if="errors.inviteCode" class="invalid-feedback">
                {{ errors.inviteCode }}
              </div>
            </div>
          </div>

          <!-- Ảnh & file đính kèm -->
          <div class="col-md-8">
            <h6 class="font-weight-bold mb-3">Ảnh & file đính kèm</h6>

            <!-- Ảnh giấy đăng ký kinh doanh -->
            <div class="form-group">
              <label>Ảnh giấy đăng ký kinh doanh <span v-if="isSupplementalUpdate" class="text-danger">*</span></label>
              <div class="image-grid">
                <div v-for="(image, index) in form.businessRegistrationNumberImages" :key="'dkkd-' + index"
                  class="image-preview">
                  <img v-if="image.preview || image.url" :src="image.preview || image.url" :alt="'ĐKKD ' + (index + 1)">
                  <div v-else class="d-flex flex-column align-items-center justify-content-center">
                    <i class="fas fa-image fa-2x text-muted mb-2"></i>
                    <small class="text-muted">{{ image.name || 'Ảnh ĐKKD' }}</small>
                  </div>
                  <!-- Hiển thị loading khi đang upload -->
                  <div v-if="image.uploading" class="upload-loading">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <button type="button" class="remove-image"
                    @click="removeFile('businessRegistrationNumberImages', index)" :disabled="image.uploading">
                    <i class='bx bx-trash' style="font-size: 20px;"></i>
                  </button>
                </div>
                <div class="image-preview upload-area" @click="triggerFileInput('businessRegistrationNumber')"
                  :class="{ 'uploading': uploadingStates.businessRegistrationNumber }">
                  <div v-if="uploadingStates.businessRegistrationNumber" class="text-center">
                    <div class="spinner-border spinner-border-sm mb-2"></div>
                    <small>Đang upload...</small>
                  </div>
                  <i v-else class='bx bx-plus' style="font-size: 30px;"></i>
                </div>
              </div>
              <input type="file" ref="businessRegistrationNumberInput"
                @change="handleFileUpload('businessRegistrationNumberImages', $event)" accept="image/*" multiple
                style="display: none;">
              <div v-if="errors.businessRegistrationNumberImages" class="invalid-feedback d-block">
                {{ errors.businessRegistrationNumberImages }}
              </div>
            </div>

            <!-- Ảnh CCCD -->
            <div class="form-group">
              <label>Ảnh CCCD <span v-if="isSupplementalUpdate" class="text-danger">*</span></label>
              <div class="image-grid">
                <div v-for="(image, index) in form.identityImages" :key="'cccd-' + index" class="image-preview">
                  <img v-if="image.preview || image.url" :src="image.preview || image.url" :alt="'CCCD ' + (index + 1)">
                  <div v-else class="d-flex flex-column align-items-center justify-content-center">
                    <i class="fas fa-image fa-2x text-muted mb-2"></i>
                    <small class="text-muted">{{ image.name || 'Ảnh CCCD' }}</small>
                  </div>
                  <div v-if="image.uploading" class="upload-loading">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <button type="button" class="remove-image" @click="removeFile('identityImages', index)"
                    :disabled="image.uploading">
                    <i class='bx bx-trash' style="font-size: 20px;"></i>
                  </button>
                </div>
                <div class="image-preview upload-area" @click="triggerFileInput('identity')"
                  :class="{ 'uploading': uploadingStates.identity }">
                  <div v-if="uploadingStates.identity" class="text-center">
                    <div class="spinner-border spinner-border-sm mb-2"></div>
                    <small>Đang upload...</small>
                  </div>
                  <i v-else class='bx bx-plus' style="font-size: 30px;"></i>
                </div>
              </div>
              <input type="file" ref="identityInput" @change="handleFileUpload('identityImages', $event)"
                accept="image/*" multiple style="display: none;">
              <div v-if="errors.identityImages" class="invalid-feedback d-block">
                {{ errors.identityImages }}
              </div>
            </div>

            <!-- File mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền PDF -->
            <div class="form-group">
              <label>File mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền (PDF) <span v-if="isSupplementalUpdate" class="text-danger">*</span></label>
              <div class="image-grid">
                <div v-for="(file, index) in form.contractFiles" :key="'contract-' + index"
                  class="image-preview d-flex flex-column align-items-center justify-content-center">
                  <i class="fas fa-file-pdf fa-2x text-danger mb-2"></i>
                  <i class='bx bxs-file-pdf' style="font-size: 50px; color: blue;"></i>
                  <small class="text-center">{{ file.name || 'mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền.pdf' }}</small>
                  <div v-if="file.uploading" class="upload-loading">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <button type="button" class="remove-image" @click="removeFile('contractFiles', index)"
                    :disabled="file.uploading">
                    <i class='bx bx-trash' style="font-size: 20px;"></i>
                  </button>
                </div>
                <div class="image-preview upload-area" @click="triggerFileInput('contract')"
                  :class="{ 'uploading': uploadingStates.contract }">
                  <div v-if="uploadingStates.contract" class="text-center">
                    <div class="spinner-border spinner-border-sm mb-2"></div>
                    <small>Đang upload...</small>
                  </div>
                  <i v-else class='bx bx-plus' style="font-size: 30px;"></i>
                </div>
              </div>
              <input type="file" ref="contractInput" @change="handleFileUpload('contractFiles', $event)" accept=".pdf"
                multiple style="display: none;">
              <div v-if="errors.contractFiles" class="invalid-feedback d-block">
                {{ errors.contractFiles }}
              </div>
            </div>

            <!-- Ảnh mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền -->
            <div class="form-group">
              <label>Ảnh mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền <span v-if="isSupplementalUpdate" class="text-danger">*</span></label>
              <div class="image-grid">
                <div v-for="(image, index) in form.contractImages" :key="'contract-img-' + index" class="image-preview">
                  <img v-if="image.preview || image.url" :src="image.preview || image.url"
                    :alt="'mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền ' + (index + 1)">
                  <div v-else class="d-flex flex-column align-items-center justify-content-center">
                    <i class="fas fa-image fa-2x text-muted mb-2"></i>
                    <small class="text-muted">{{ image.name || 'Ảnh mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền' }}</small>
                  </div>
                  <div v-if="image.uploading" class="upload-loading">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <button type="button" class="remove-image" @click="removeFile('contractImages', index)"
                    :disabled="image.uploading">
                    <i class='bx bx-trash' style="font-size: 20px;"></i>
                  </button>
                </div>
                <div class="image-preview upload-area" @click="triggerFileInput('contractImage')"
                  :class="{ 'uploading': uploadingStates.contractImage }">
                  <div v-if="uploadingStates.contractImage" class="text-center">
                    <div class="spinner-border spinner-border-sm mb-2"></div>
                    <small>Đang upload...</small>
                  </div>
                  <i v-else class='bx bx-plus' style="font-size: 30px;"></i>
                </div>
              </div>
              <input type="file" ref="contractImageInput" @change="handleFileUpload('contractImages', $event)"
                accept="image/*" multiple style="display: none;">
              <div v-if="errors.contractImages" class="invalid-feedback d-block">
                {{ errors.contractImages }}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <b-modal size="xs" v-model="toastModal.show" scrollable centered title="Thông báo">
      <div class="modal-body text-center">
        <img v-if="toastModal.success" src="@/assets/img/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-unsuccesss" />
        <h2 class="f18 py-3">{{ toastModal.title }}</h2>
        <p class="text-center" style="font-size: 14px;">
          {{ toastModal.content }}
        </p>
      </div>
      <template #modal-footer="{ }">
        <button type="button" class="btn btn-light" @click="closeAdd()" data-dismiss="modal">
          Đóng
        </button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import { CommonService } from '@/services/common.service'
import { ComboService } from '../../services/combo.service'

export default {
  name: 'ComboRegistrationForm',
  data () {
    return {
      modalTitle: '',
      modalMessage: '',
      loading: false,
      isEdit: false,
      isSupplementalUpdate: false,
      showActionModal: false,
      idUpdate: this.$router.currentRoute.params.id,
      uploadingStates: {
        businessRegistrationNumber: false,
        identity: false,
        contract: false,
        contractImage: false
      },
      toastModal: {
        show: false,
        success: true,
        title: '',
        content: ''
      },
      form: {
        merchantName: '',
        businessRegistrationNumber: '',
        merchantAddress: '',
        representativeName: '',
        representativeEmail: '',
        representativeMobile: '',
        identityNumber: '',
        inviteCode: '',
        businessRegistrationNumberImages: [],
        identityImages: [],
        contractFiles: [],
        contractImages: [],
        packageCode: ''
      },
      errors: {},
      optionCombo:[],
      dataUser: JSON.parse(localStorage.getItem('userData'))

    }
  },

  mounted () {
    this.isEdit = !!this.idUpdate
    this.isSupplementalUpdate = this.$route.query.action === 'SUPPLEMENTAL_UPDATE'

    if (this.idUpdate) {
      this.loadEditData()
    }
    this.loadpackageCodes()
  },

  methods: {
    async loadpackageCodes () {
      try {
        const data = await ComboService.getPlaneServiceCommbo({
          page: 1,
          size: 1000
        })
        if (data.code === 1000) {
          const groupService = data.data?.groupService?.find(e => e.group === 'SELL')
          const comboService = groupService?.service?.find(e => e.code === 'COMBOSELL')
          const plans = comboService?.plan || []
          const newData = plans?.filter(e => Array.isArray(e?.partnerEnable) && e.partnerEnable.includes(`${this.dataUser?.partnerCode}_DIGITAL`)) || [];
          this.dataCombo = newData || []
          this.optionCombo = newData?.map(e => {
            return {
              id: e.code,
              text: e.title,
              partnerPrice: e.partnerPrice
            }
          }) || []
        }
      } catch (error) {
        console.log(error)
      }
    },
    showToastModal (success, title, content) {
      this.toastModal = {
        show: true,
        success: success,
        title: title,
        content: content
      }
    },
    getPageTitle () {
      if (this.isSupplementalUpdate) {
        return 'Bổ sung tài liệu yêu cầu đăng ký Combo bán hàng'
      }
      return this.isEdit ? 'Cập nhật yêu cầu đăng ký Combo bán hàng' : 'Tạo mới yêu cầu đăng ký Combo bán hàng'
    },

    // partnerCode
    async loadEditData () {
      try {
        this.loading = true
        // Gọi API lấy data để edit
        const response = await ComboService.detailCombo(this.idUpdate)
        const data = response.data

        // Map data từ server về form
        this.form = {
          merchantName: data.merchantName || '',
          businessRegistrationNumber: data.businessRegistrationNumber || '',
          merchantAddress: data.merchantAddress || '',
          representativeName: data.representativeName || '',
          representativeEmail: data.representativeEmail || '',
          representativeMobile: data.representativeMobile || '',
          identityNumber: data.identityNumber || '',
          inviteCode: data.inviteCode || '',
          inviterEmail: data.inviterEmail || '',
          businessRegistrationNumberImages: this.mapLinksToFileObjects(data.businessRegistrationNumberImages || []),
          identityImages: this.mapLinksToFileObjects(data.identityImages || []),
          contractFiles: this.mapLinksToFileObjects(data.contractFiles || []),
          contractImages: this.mapLinksToFileObjects(data.contractImages || []),
          packageCode: data.packageCode
        }
      } catch (error) {
        console.error('Error loading edit data:', error)
        this.showToastModal(false, 'Thât bại', error.message || 'Lỗi upload file')
      } finally {
        this.loading = false
      }
    },

    mapLinksToFileObjects (links) {
      return links.map(link => ({
        url: link,
        name: this.getFileNameFromUrl(link),
        isExisting: true,
        uploaded: true
      }))
    },

    getFileNameFromUrl (url) {
      return url.split('/').pop() || 'file'
    },

    triggerFileInput (type) {
      // Kiểm tra đang upload không
      if (this.uploadingStates[type]) {
        return
      }

      const inputMap = {
        businessRegistrationNumber: 'businessRegistrationNumberInput',
        identity: 'identityInput',
        contract: 'contractInput',
        contractImage: 'contractImageInput'
      }
      this.$refs[inputMap[type]].click()
    },
    closeAdd () {
      this.$router.back()
    },
    async handleFileUpload (fieldName, event) {
      const files = Array.from(event.target.files)
      if (!files.length) return

      // Xác định loại upload
      const uploadType = this.getUploadTypeFromFieldName(fieldName)
      this.uploadingStates[uploadType] = true

      try {
        for (const file of files) {
          // Validate file
          if (!this.validateFile(file, fieldName)) {
            continue
          }

          // Thêm file vào form với trạng thái uploading
          const fileObj = await this.createFileObject(file, fieldName)
          this.form[fieldName].push(fileObj)

          // Upload file
          await this.uploadSingleFile(fileObj, fieldName)
        }
      } catch (error) {
        console.error('Upload error:', error)
        this.showToastModal(false, 'Thât bại', error.message || 'Lỗi upload file')
      } finally {
        this.uploadingStates[uploadType] = false
        // Reset input
        event.target.value = ''
      }
    },

    validateFile (file, fieldName) {
      const maxSize = 10 * 1024 * 1024 // 10MB

      if (file.size > maxSize) {
        this.showToastModal(false, 'Thât bại', `File ${file.name} quá lớn. Kích thước tối đa 10MB`)
        return false
      }

      // Validate file type
      if (fieldName === 'contractFiles') {
        if (!file.type.includes('pdf')) {
          this.showToastModal(false, 'Thât bại', `File ${file.name} phải là định dạng PDF`)
          return false
        }
      } else {
        if (!file.type.startsWith('image/')) {
          this.showToastModal(false, 'Thât bại', `File ${file.name} phải là định dạng ảnh`)
          return false
        }
      }

      return true
    },

    async createFileObject (file, fieldName) {
      const fileObj = {
        file: file,
        name: file.name,
        url: null,
        isNew: true,
        uploading: true,
        uploaded: false
      }

      // Tạo preview cho ảnh
      if (fieldName !== 'contractFiles') {
        fileObj.preview = await this.createImagePreview(file)
      }

      return fileObj
    },

    async uploadSingleFile (fileObj, fieldName) {
      try {
        const formData = new FormData()
        formData.append('files', fileObj.file)
        formData.append('folderName', 'ComboRegistration')

        let response
        if (fieldName === 'contractFiles') {
          // Upload file PDF
          response = await CommonService.uploadFile(formData)
        } else {
          // Upload ảnh
          response = await CommonService.uploadImage(formData)
        }

        if (response.code === 1000) {
          // Upload thành công
          fileObj.url = response.data[0] || ''
          fileObj.uploaded = true
          fileObj.uploading = false
        } else {
          throw new Error(response.message || 'Upload failed')
        }
      } catch (error) {
        console.error('Upload file error:', error)
        fileObj.uploading = false
        fileObj.uploadError = true

        // Xóa file lỗi khỏi danh sách
        const index = this.form[fieldName].indexOf(fileObj)
        if (index > -1) {
          this.form[fieldName].splice(index, 1)
        }

        throw error
      }
    },

    getUploadTypeFromFieldName (fieldName) {
      const typeMap = {
        businessRegistrationNumberImages: 'businessRegistrationNumber',
        identityImages: 'identity',
        contractFiles: 'contract',
        contractImages: 'contractImage'
      }
      return typeMap[fieldName]
    },

    createImagePreview (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(e.target.result)
        reader.readAsDataURL(file)
      })
    },

    removeFile (fieldName, index) {
      this.form[fieldName].splice(index, 1)
    },

    validateForm () {
      this.errors = {}

      // Validation cho tạo mới và cập nhật thường
      if (!this.isSupplementalUpdate) {
        if (!this.form.merchantName.trim()) {
          this.errors.merchantName = 'Tên merchant là bắt buộc'
        }
        if (!this.form.businessRegistrationNumber.trim()) {
          this.errors.businessRegistrationNumber = 'Số ĐKKD là bắt buộc'
        }
        if (!this.form.merchantAddress.trim()) {
          this.errors.merchantAddress = 'Địa chỉ cửa hàng / merchant là bắt buộc'
        }
        if (!this.form.representativeName.trim()) {
          this.errors.representativeName = 'Tên chủ cửa hàng là bắt buộc'
        }
        if (!this.form.inviterEmail.trim()) {
          this.errors.inviterEmail = 'Email người giới thiệu là bắt buộc'
        } else if (!this.validateEmail(this.form.inviterEmail)) {
          this.errors.inviterEmail = 'Email không đúng định dạng'
        }
        if (!this.form.representativeEmail.trim()) {
          this.errors.representativeEmail = 'Email chủ cửa hàng là bắt buộc'
        } else if (!this.validateEmail(this.form.representativeEmail)) {
          this.errors.representativeEmail = 'Email không đúng định dạng'
        }
        if (!this.form.representativeMobile.trim()) {
          this.errors.representativeMobile = 'Mobile chủ cửa hàng là bắt buộc'
        } else if (!this.validatePhone(this.form.representativeMobile)) {
          this.errors.representativeMobile = 'Số điện thoại không đúng định dạng'
        }
        if (!this.form.identityNumber.trim()) {
          this.errors.identityNumber = 'CCCD chủ cửa hàng là bắt buộc'
        }
      }

      // Validation cho cập nhật bổ sung - cho phép cập nhật tên MC và ĐKKD
      if (this.isSupplementalUpdate) {
        if (!this.form.merchantName.trim()) {
          this.errors.merchantName = 'Tên merchant là bắt buộc'
        }
        if (!this.form.businessRegistrationNumber.trim()) {
          this.errors.businessRegistrationNumber = 'Số ĐKKD là bắt buộc'
        }
        if (!this.form.merchantAddress.trim()) {
          this.errors.merchantAddress = 'Địa chỉ cửa hàng / merchant là bắt buộc'
        }
        if (!this.form.representativeName.trim()) {
          this.errors.representativeName = 'Tên chủ cửa hàng là bắt buộc'
        }
        if (!this.form.inviterEmail.trim()) {
          this.errors.inviterEmail = 'Email người giới thiệu là bắt buộc'
        } else if (!this.validateEmail(this.form.inviterEmail)) {
          this.errors.inviterEmail = 'Email không đúng định dạng'
        }
        if (!this.form.representativeEmail.trim()) {
          this.errors.representativeEmail = 'Email chủ cửa hàng là bắt buộc'
        } else if (!this.validateEmail(this.form.representativeEmail)) {
          this.errors.representativeEmail = 'Email không đúng định dạng'
        }
        if (!this.form.representativeMobile.trim()) {
          this.errors.representativeMobile = 'Mobile chủ cửa hàng là bắt buộc'
        } else if (!this.validatePhone(this.form.representativeMobile)) {
          this.errors.representativeMobile = 'Số điện thoại không đúng định dạng'
        }
        if (!this.form.identityNumber.trim()) {
          this.errors.identityNumber = 'CCCD chủ cửa hàng là bắt buộc'
        }
      }

      // Kiểm tra có file đang upload không
      const hasUploadingFiles = this.checkUploadingFiles()
      if (hasUploadingFiles) {
        this.showToastModal(false, 'Thất bại', 'Vui lòng đợi upload file hoàn tất')
        return false
      }

      return Object.keys(this.errors).length === 0
    },

    checkUploadingFiles () {
      const allFiles = [
        ...this.form.businessRegistrationNumberImages,
        ...this.form.identityImages,
        ...this.form.contractFiles,
        ...this.form.contractImages
      ]

      return allFiles.some(file => file.uploading)
    },

    getUploadedUrls () {
      const uploadedUrls = {}

      // Lấy URLs từ các file đã upload
      for (const fieldName of ['businessRegistrationNumberImages', 'identityImages', 'contractFiles', 'contractImages']) {
        uploadedUrls[fieldName] = this.form[fieldName]
          .filter(file => file.uploaded && file.url)
          .map(file => file.url)
      }

      return uploadedUrls
    },
    validateEmail (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },

    validatePhone (phone) {
      const phoneRegex = /^[0-9]{10,11}$/
      return phoneRegex.test(phone.replace(/\s/g, ''))
    },
    async save () {
      if (!this.validateForm()) {
        return
      }

      try {
        this.loading = true

        // Lấy URLs đã upload
        const uploadedUrls = this.getUploadedUrls()

        // Tạo body request
        const requestBody = {
          merchantAddress: this.form.merchantAddress.trim(),
          representativeName: this.form.representativeName.trim(),
          representativeEmail: this.form.representativeEmail.trim(),
          representativeMobile: this.form.representativeMobile.trim(),
          identityNumber: this.form.identityNumber.trim(),
          inviteCode: this.form.inviteCode.trim(),
          businessRegistrationNumberImages: uploadedUrls.businessRegistrationNumberImages,
          identityImages: uploadedUrls.identityImages,
          contractFiles: uploadedUrls.contractFiles,
          contractImages: uploadedUrls.contractImages,
          inviterEmail: this.form.inviterEmail.trim(),
          packageCode: this.form.packageCode

        }

        // Chỉ thêm merchantName và businessRegistrationNumber khi không phải SUPPLEMENTAL_UPDATE
        if (!this.isSupplementalUpdate) {
          requestBody.merchantName = this.form.merchantName.trim()
          requestBody.businessRegistrationNumber = this.form.businessRegistrationNumber.trim()
        }

        // Gọi API
        if (this.isEdit) {
          requestBody.id = this.idUpdate
          requestBody.actionType = this.isSupplementalUpdate ? 'SUPPLEMENTAL_UPDATE' : 'UPDATE'
          await ComboService.editCombo(requestBody)
          this.showToastModal(true, 'Thành công', 'Cập nhật thành công')
        } else {
          await ComboService.addCombo(requestBody)
          this.showToastModal(true, 'Thành công', 'Tạo mới thành công')
        }

        // Redirect hoặc emit event
      } catch (error) {
        this.showToastModal(false, 'Thất bại', error.message || 'Có lỗi xảy ra khi lưu dữ liệu')
      } finally {
        this.loading = false
      }
    },

    cancel () {
      this.goBack()
    },

    hasChanges () {
      // Logic kiểm tra có thay đổi dữ liệu không
      return this.form.merchantName ||
    this.form.businessRegistrationNumber ||
    this.form.merchantAddress ||
    this.form.representativeName ||
    this.form.representativeEmail ||
    this.form.representativeMobile ||
    this.form.identityNumber ||
    this.form.inviteCode ||
    this.form.businessRegistrationNumberImages.length > 0 ||
    this.form.identityImages.length > 0 ||
    this.form.contractFiles.length > 0 ||
    this.form.contractImages.length > 0
    },

    goBack () {
      this.$router.push('/sales-combos')
    }
  }
}
</script>

<style scoped>
.upload-area {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s;
  min-height: 100px;
}

.upload-area:hover {
  border-color: #007bff;
  background: #e3f2fd;
}

.upload-area.uploading {
  cursor: not-allowed;
  opacity: 0.7;
}

.image-preview {
  width: 100px;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255, 0, 0, 0.8);
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-image:hover:not(:disabled) {
  background: rgba(255, 0, 0, 1);
}

.remove-image:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.breadcrumb-area {
  height: 24px;
}

.breadcrumb-area {
  display: flex;
  height: 24px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Style cho input bị disabled */
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
</style>
